import { isNotEmptyString } from '@weft/utils';
import { getLocalStorageString } from '.';

export function removeLocalStorageEntry(key: string) {
  return localStorage.removeItem(key);
}

export function localStorageExists(key: string) {
  const item = getLocalStorageString(key);

  return isNotEmptyString(item);
}